import request from '@/utils/request'

// 探测登录态（网关解析 httpOnly Cookie 返回用户信息）
export async function fetchMe() {
  return request({ url: '/auth/oidc/me', method: 'get' })
}

// 登录跳转地址（统一 /api 前缀，经代理剥掉后转发网关）
export function ssoLoginUrl(redirectPath) {
  const redirect = encodeURIComponent(window.location.origin + (redirectPath || '/'))
  // 清父域皮肤 Cookie：默认样式走原版登录页，不受其它平台皮肤残留影响
  const host = window.location.hostname
  const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host)
  const domain = (!isIp && host !== 'localhost' && host.split('.').length >= 2)
    ? `; domain=.${host.split('.').slice(-2).join('.')}`
    : ''
  document.cookie = `clife_skin=default; path=/; max-age=2592000; SameSite=Lax${domain}`
  return '/api/auth/oidc/login?redirect=' + redirect
}

// 登出跳转地址
export function ssoLogoutUrl(redirectPath) {
  const redirect = encodeURIComponent(window.location.origin + (redirectPath || '/'))
  return '/api/auth/oidc/logout?redirect=' + redirect
}
